<template>
  <div class="page">
    <div class="down-wrap">
      <div class="btn" @click="down">立即下载云校APP</div>
      <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/h5/page1/01.png" />
    </div>
    <div class="i2-wrap">
      <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/h5/page1/02.png" />
    </div>
    <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/h5/page1/03.png" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: '校管家云校',
      channelType: this.$route.query.channelType || '',
    };
  },
  methods: {
    sendStatistics(eventType = 1) {
      this.$api.addChannelStatistics({
        pageId: '2',
        pageName: '云校APP下载落地页',
        channelType: this.channelType,
        eventType: eventType,
      });
    },
    down() {
      if (app.base.isIos) {
        this.sendStatistics(3);
        //苹果跳下载链接
        window.open('https://itunes.apple.com/cn/app/id1571838977');
      } else {
        this.sendStatistics(2);
        //安卓跳下载链接
        window.location.href =
          'https://cdn01.xiaogj.com/uploads/mobile/app-yunxiao/apk/yunxiao_facein.apk';
      }
    },
  },
  created() {
    this.sendStatistics(1);
  },
};
</script>

<style lang="scss" scoped>
.page {
  margin: 0 auto;
  max-width: 600px;
  font-size: 0;
}
img {
  width: 100%;
}
.down-wrap {
  position: relative;
  .btn {
    margin-top: 98.5%;
    position: absolute;
    width: 70%;
    margin-left: 15%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
    background: linear-gradient(180deg, #1873ff 0%, #1873ff 100%);
    box-shadow: 0px 10px 10px -4px rgba(24, 115, 255, 0.45);
    border-radius: 70px;
  }
}
.i2-wrap {
  padding: 7.2% 4% 0;
}
</style>